module.exports = __webpack_public_path__ + "components/roadsurfer/static/roadsurfer-1200-56417aa99d6821299cc803d69f185c2e.webp";